import { render, staticRenderFns } from "./calendarSync.vue?vue&type=template&id=8bc8e1f6&lang=pug"
import script from "./calendarSync.vue?vue&type=script&lang=js"
export * from "./calendarSync.vue?vue&type=script&lang=js"
import style0 from "./calendarSync.vue?vue&type=style&index=0&id=8bc8e1f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports